import { createAction } from 'redux-act'

export const fetchUspBannerStart = createAction('usp - fetch usp banner start')

export const fetchUspBannerSuccess = createAction<any>('usp - fetch usp banner success')

export const fetchUspBannerFail = createAction<any>('usp - fetch usp banner fail')
